import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Archive(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 14a1 1 0 01-1 1H8a1 1 0 01-1-1v-2a1 1 0 011-1h8a1 1 0 011 1v2zm-1-2v2H8v-2h8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 8a1 1 0 001 1v11a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 001-1V5a1 1 0 00-1-1H3a1 1 0 00-1 1v3zm19 0H3V5h18v3zM4 20V9h16v11H4z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Archive);
export default ForwardRef;